import {Injectable} from '@angular/core';
import {LoadingService} from '../loading/loading.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  isInApp$: Promise<boolean>;
  isSetCompanyIdPayrollId$: Promise<boolean>;
  isSetHasOnlyCompanyId$: Promise<boolean>;

  constructor(
    private loadingService: LoadingService,
  ) {
    this.isInApp$ = this.isInApp();
    this.isSetCompanyIdPayrollId$ = this.isSetCompanyIdPayrollId();
    this.isSetHasOnlyCompanyId$ = this.isSetHasOnlyCompanyId();
  }

  getAppPlatform(): Promise<string | null> {
    return new Promise(resolve =>
      setTimeout(() =>
          resolve(localStorage.getItem('itax_app_platform'))
        , 2000)
    );
  }

  async isInApp(): Promise<boolean> {
    this.loadingService.set(true, 'platform');
    const platform = await this.getAppPlatform();
    this.loadingService.set(false, 'platform');
    return (platform === 'ios' || platform === 'android');
  }

  getPlatformStatus(): Observable<any> {
    return new Observable(observable => {
      this.isInApp$.then(res => {
        observable.next(res);
        observable.complete();
      });
    });
  }

  getCompanyIdPayrollId(): Promise<boolean | null> {
    return new Promise(resolve =>
      setTimeout(() => {
        const company = localStorage.getItem('company_id');
        const payroll = localStorage.getItem('payroll_id');
        resolve(company !== null && payroll !== null);
      }, 2000)
    );
  }

  async isSetCompanyIdPayrollId(): Promise<boolean> {
    this.loadingService.set(true, 'platform');
    const isAlready = await this.getCompanyIdPayrollId();
    this.loadingService.set(false, 'platform');
    return isAlready;
  }

  getSetCompanyIdPayrollIdStatus(): Observable<any> {
    return new Observable(observable => {
      this.isSetCompanyIdPayrollId$.then(res => {
        observable.next(res);
        observable.complete();
      });
    });
  }

  getHasOnlyCompanyId(): Promise<boolean | null> {
    return new Promise(resolve =>
      setTimeout(() => {
        const company = localStorage.getItem('company_id');
        const payroll = localStorage.getItem('payroll_id');
        resolve(company !== null && payroll === null);
      }, 2000)
    );
  }

  async isSetHasOnlyCompanyId(): Promise<boolean> {
    this.loadingService.set(true, 'platform');
    const isAlready = await this.getHasOnlyCompanyId();
    this.loadingService.set(false, 'platform');
    return isAlready;
  }

  getSetHasOnlyCompanyId(): Observable<any> {
    return new Observable(observable => {
      this.isSetHasOnlyCompanyId$.then(res => {
        observable.next(res);
        observable.complete();
      });
    });
  }

  clearOthersLocalStorageInApp(): void {
    localStorage.removeItem('company_id');
    localStorage.removeItem('payroll_id');
    localStorage.removeItem('payroll_app_action');
  }

  closeWebView(): void {
    this.clearOthersLocalStorageInApp();
    window.location.href = '//itax//?event=close';
  }

  closeAndRefreshWebView(): void {
    this.clearOthersLocalStorageInApp();
    window.location.href = '//itax//?event=close_and_refresh';
  }

  openEKYC(): void {
    window.location.href = '//itax//?event=ekyc';
  }
}
